"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const campaignCrmFields_1 = require("./campaignCrmFields");
exports.IMPRESSION = 'impression';
exports.CLICK = 'click';
exports.COLLECT = 'collect';
exports.LOGIN_FB = 'fb';
exports.LOGIN_GG = 'gg';
exports.SEND_SMS = 'sms';
exports.VERIFY_SMS = 'verifySms';
exports.SEND_EMAIL = 'email';
exports.VERIFY_EMAIL = 'verifyEmail';
exports.metaFields = ['campaignId', 'locationId', 'realLocationId', 'bannerId', 'equipmentId'];
exports.audienceFieldsExtended = [...campaignCrmFields_1.audienceFields, 'emailVerified', 'phoneVerified'];
exports.fieldMappings = {
    mac: 'm',
    isNew: 'in',
    uaString: 'ua',
    bannerId: 'bi',
    campaignId: 'ci',
    campaignCategoryId: 'cci',
    locationId: 'li',
    equipmentId: 'ei',
    fbCode: 'code',
    deviceName: 'dn',
    deviceCode: 'dc',
    brandName: 'brn',
};
//# sourceMappingURL=actions.js.map